import { render, staticRenderFns } from "./serviceInformation.vue?vue&type=template&id=bc4a92f0&scoped=true&"
import script from "./serviceInformation.vue?vue&type=script&lang=js&"
export * from "./serviceInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4a92f0",
  null
  
)

export default component.exports